
import emails from '../api/emails'

export const state = {
  emails: [],
  email_pagination_data: {},
  email: ''
}

export const getters = {
  emails: state => state.emails,
  email_pagination_data: state => state.email_pagination_data,
  email: state => state.email
}

export const mutations = {
  ADD_EMAIL (state, data) {
    state.emails.push(data)
  },
  SET_EMAILS (state, data) {
    state.emails = data
  },
  SET_EMAIL_PAGINATION (state, data) {
    state.email_pagination_data = data
  },
  SHOW_EMAIL (state, data) {
    state.email = data
  }
}

export const actions = {
  GET_EMAILS ({ commit, getters }, data) {
    return new Promise((resolve, reject) => {
      emails.get(data).then(response => {
        commit('SET_EMAILS', response.data.data)
        let paginationData = {
          from: response.data.from,
          to: response.data.to,
          total: response.data.total,
          last_page: response.data.last_page
        }
        commit('SET_EMAIL_PAGINATION', paginationData)
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  CREATE_EMAIL ({ commit, getters }, data) {
    return new Promise((resolve, reject) => {
      emails.create(data).then(response => {
        commit('ADD_EMAIL', response.data)
        resolve(response)
      }, error => {
        reject(error)
      })
    })
  },
  SHOW_EMAIL ({ commit, getters }, data) {
    return new Promise((resolve, reject) => {
      emails.get(data).then(response => {
        commit('SHOW_EMAIL', response.data)
        resolve(response)
      }, error => {
        reject(error)
      })
    })
  },
  EDIT_EMAIL ({ commit, getters }, data) {
    return new Promise((resolve, reject) => {
      emails.update(data.data, data.id).then(response => {
        resolve(response)
      }, error => {
        reject(error)
      })
    })
  },
  REMOVE_EMAIL ({ commit, getters }, id) {
    return new Promise((resolve, reject) => {
      emails.delete(id).then(response => {
        resolve(response)
      }, error => {
        reject(error)
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/email-settings.js